import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import ViewEmployee from "../view";
import { MODULE_EMPLOYEES } from "variables/constants";

const employeeDocumentRoutes = [
    generateCRUDRoutes({
        mainTitle: "Employee Documents",
        basePath: "employees/:employeeId/documents",
        mainComponent: <ViewEmployee />,
        layout: "/console",	   
        subTitle:"Employee Document",
        level:4,
        moduleId: MODULE_EMPLOYEES,  
    })
]

export default employeeDocumentRoutes;